import { HttpClient, HttpHeaders, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-browser';
import { SharedService } from './shared.service';

@Injectable({ providedIn: 'root' })
export class AuthService {

  public static viewTodoList = 'TodoList.View';
  public static viewReviewPurchases = 'ReviewPurchases.View';
  public static migratePurchases = 'ReviewPurchases.Migrate';
  public static viewUpjar = 'Upjar.View';
  public static exemptFromQuiz = 'Quiz.Exempt';
  public static viewDashboard = 'PPX.Dashboard';
  public static viewTrophies = 'TrophyCabinet.View';
  public photoUrl: string;

  constructor(private msalService: MsalService, private http: HttpClient, private sharedService: SharedService) {
  }

  login(): void {
    this.msalService.loginRedirect();
  }

  logout(): void {
    this.sharedService.removeSessionStorageItem("apiCalled");
    this.msalService.logout();
  }

  getUser(): AccountInfo {
    const currentAccounts = this.msalService.instance.getAllAccounts();
    return currentAccounts[0];
  }

  getUsername(): string {
    const account = this.getUser();
    return account ? account.username.replace('@webuyanycar.com', '').toLocaleLowerCase() : '';
  }

  getEmailAddress(): string {
    const account = this.getUser();
    return account ? account.username : '';
  }

  async getUserPhoto() {
    const apiCalled = this.sharedService.getSessionStorageItem('apiCalled');

    if (apiCalled) {
      return;
    } else {
      const instance = this.msalService.instance;

      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if (!(instance as any).initialized) {
        await instance.initialize();
      }

      const account = this.getUser();
      const tokenResponse = await this.msalService.instance.acquireTokenSilent({
        account,
        scopes: ['User.Read']
      });

      try {
        const headers = new HttpHeaders({
          Authorization: `Bearer ${tokenResponse.accessToken}`
        });

        this.http.get('https://graph.microsoft.com/v1.0/me/photo/$value', { headers, responseType: 'blob' })
          .subscribe({
            next: (imageBlob) => {
              if (imageBlob) {
                this.photoUrl = URL.createObjectURL(imageBlob);
              }
              return this.photoUrl;
            },
            error: (err) => {
              this.sharedService.setItem('apiCalled', true);
              // Error Fallback if not a success req
              if (err.status === HttpStatusCode.NotFound) {
                return this.photoUrl;
              }
            }
          });
      } catch (err) {
        this.sharedService.setItem('apiCalled', true);
        console.error(err);
        return this.photoUrl;
      }
    }
  }

  async getUserJobTitle(): Promise<string> {
    const account = this.getUser();

    const tokenResponse = await this.msalService.instance.acquireTokenSilent({
      account,
      scopes: ['User.Read']
    });

    const response = await fetch('https://graph.microsoft.com/v1.0/me', {
      headers: { Authorization: `Bearer ${tokenResponse.accessToken}` }
    });

    const data = await response.json();
    return data.jobTitle ?? '';
  }
}
